import AbstractGeoLoc from '@phoenix/components/AbstractGeoLoc';
import { Collapse } from '@maison/Toolkit';

export default class GeoLoc extends AbstractGeoLoc {
  showPropositionBanner(): void {
    const collapse = document.querySelector(this.COUNTRY_PROPOSITION_BANNER_SELECTOR);
    if (collapse) {
      collapse.classList.add('is-expanded');
      new Collapse(collapse);
    }
  }
}
